import React from "react";
import PropTypes from "prop-types";

const Funnel = (props) => {
  return (
    <div>
      <svg
        width="20"
        height="20"
        viewBox="0 0 14 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5.91163 10.8596V9.70405H8.22274V10.8596H5.91163ZM3.60052 7.97071V6.81516H10.5339V7.97071H3.60052ZM1.86719 5.08182V3.92627H12.2672V5.08182H1.86719Z"
          fill="#039D55"
        />
      </svg>
    </div>
  );
};

Funnel.propTypes = {};

export default Funnel;
